import Vuex from 'vuex'
import Vue from 'vue'
import * as actions from './actions'
import * as getters from './getters'
import mutations from './mutations'

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

const state = {
  cart: {
    number: null,
    category: null,
    parts: [],
    letters: [],
    packs: [
      {
        size_name: null,
        size_id: "",
        value: null,
        number: "",
        name: null,
        pack_price: null,
      }
    ],
    figure: null,
    design: null,
    order: {
      email: null,
      name: null,
      zip: null,
      address: null,
      street: null,
      tel: null,
      comment: null,
    },
  },
  stock_cart: [],
  order: {
    email: null,
    name: null,
    zip: null,
    address: null,
    street: null,
    tel: null,
    payment_method: null,
    comment: null,
  },
  fonts:[],
  sizes:[],
  // colors:[],
  active_tab: 'category',
  loading: false,
  page: 'design',
  product_tab: {
    // activeIndex: 1,
    buttons:[
      {code:'category', name:'アイテム', disabled:false},
      {code:'product-figure', name:'タイプ', disabled:true},
      {code:'design', name:'デザイン', disabled:true},
      {code:'color', name:'カラー', disabled:true},
      {code:'font', name:'オプション', disabled:true},
      {code:'estimate', name:'サイズ/数量', disabled:true},
    ],
  },
  reverse: false,
  modals: []
};

export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations,
  strict: debug,
})
